import React from "react";

export default function VideoSelector({ 
  videos, 
  currentVideoUrl, 
  onSelectVideo 
}) {
  if (!videos || videos.length <= 1) return null;

  return (
    <div className="lrp-video-selector">
      {videos.map((v, idx) => (
        <button
          key={v.key || idx}
          onClick={() => onSelectVideo(v.url)}
          className={`lrp-video-selector-btn ${currentVideoUrl === v.url ? 'is-active' : ''}`}
          title={v.name || `Video ${idx + 1}`}
          aria-label={`Select video ${idx + 1}`}
        >
          {v.name || `Video ${idx + 1}`}
        </button>
      ))}
    </div>
  );
}
